<template>
  <ParentPortal :tabs="sidePanelComponents">
    <router-view v-if="nomination"
                 :award="nomination.award"
                 :nomination="nomination"
                 class="main-content"/>
  </ParentPortal>
</template>

<script>
/* eslint-disable vue/no-unused-components */
import {
  IfacAwardDetails,
  IfacNominationReferences,
  IfacNominationReports,
} from '@ifac/ui';
import nominationsMixin from '@/mixins/awards/nominations.mixin';
import ParentPortal from '@/views/components/portals/ParentPortal.vue';
import { mapGetters } from 'vuex';

export default {
  mixins: [nominationsMixin],
  name: 'NominationsEditPortal',
  components: {
    ParentPortal,
    IfacAwardDetails,
    IfacNominationReferences,
    IfacNominationReports,
  },
  created() {
    this.mx_fetchNomination().then((response) => {
      this.nomination = response.data.data;
    });
  },
  data() {
    return {
      nomination: null,
    };
  },
  computed: {
    ...mapGetters({
      user: 'auth/user',
    }),
    sidePanelComponents() {
      const tabs = [
        {
          icon: ['far', 'award'],
          headerText: 'Award',
          component: IfacAwardDetails,
          options: {
            award: this.nomination?.award,
            nomination: this.nomination,
            isLoading: false,
          },
        },
      ];

      // Reference letters
      if (this.nomination?.can.viewReferences) {
        tabs.push({
          icon: ['far', 'envelope'],
          headerText: 'Reference letters',
          component: IfacNominationReferences,
          options: {
            nomination: this.nomination,
            isLoading: false,
          },
        });
      }

      // Reports
      if (this.nomination?.can.viewReports) {
        tabs.push({
          icon: ['far', 'file-chart-column'],
          headerText: 'Reports',
          component: IfacNominationReports,
          options: {
            nomination: this.nomination,
            isLoading: false,
          },
        });
      }

      return tabs;
    },
  },
};
</script>
